import React, { useContext, useEffect, useState } from 'react';
import MenuItems from './MenuItems';
import { FaBars, FaTimes } from 'react-icons/fa';
import Pictures from '../../assets/picture';
import { Link } from 'react-router-dom';
import './Navigation.scss';
import './ResponsiveNav.scss';
import LanguageDropdown from './LanguageDropdown/LanguageDropdown';
import Basket from './Basket/Basket';
import { NavigationContext } from '../../context/Navigation';
import CtaButton from './CtaButton';
import Hooks from '../../hooks';
import { BergWeather } from '@berg-regions/berg-components';

const getWindowSize = () => {
  const { innerWidth } = window;
  return { innerWidth };
};

const Navigation = () => {
  const [windowSize, setWindowSize] = useState(getWindowSize());

  const { navRef, isMobileMenuVisible, toggleMobileMenuVisibility } =
    useContext(NavigationContext);

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [windowSize]);

  const { weatherCode, temperature, sunrise, sunset, localTime } =
    Hooks.useAppSelector((s) => s.weather.data) ?? {};

  return (
    <nav className="berg-components-navigation">
      <div className="berg-components-navigation-picture">
        <Link to="/">
          <img src={Pictures.LogoColor} alt="logo" />
        </Link>
      </div>
      <ul className="berg-components-navigation-list" ref={navRef}>
        <MenuItems
          isMobileMenuVisible={isMobileMenuVisible}
          toggleMobileMenuVisibility={toggleMobileMenuVisibility}
        />
        <li className="berg-components-menu-item">
          <BergWeather
            weatherCode={weatherCode}
            temperature={temperature}
            sunrise={sunrise}
            sunset={sunset}
            localTime={localTime}
            iconColor="white"
            textColor="white"
            color="white"
            imgSize={24}
            tempFontSize={16}
            tempFontWeight={400}
            className="justify-center h-full"
          />
        </li>
        {windowSize.innerWidth >= 1024 && (
          <li className="berg-components-menu-item-shopping-cart">
            <Basket />
          </li>
        )}
        <li className="berg-components-menu-item-language">
          <LanguageDropdown />
        </li>
      </ul>

      <CtaButton />

      {windowSize.innerWidth < 1024 && (
        <div className="berg-components-menu-item-shopping-cart">
          <Basket />
        </div>
      )}
      <span id="mobile-search-btn" />
      <button
        className="berg-components-navigation-hamburger-btn"
        onClick={toggleMobileMenuVisibility}
      >
        {isMobileMenuVisible ? <FaTimes /> : <FaBars />}
      </button>
    </nav>
  );
};

export default Navigation;
